"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateNotificationEmails = exports.UpdateNotificationEmails = exports.UpdateNotificationEmailsActionTypes = exports.loadNotificationEmails = exports.FetchNotificationEmailData = exports.FetchNotificationEmailDataActionTypes = exports.FetchNotificationEmails = exports.FetchNotificationEmailsActionTypes = exports.NotificationEmailsActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _actions = require("settings-ui-sdk/utils/actions");

var _fluxActions = require("flux-actions");

var _I18n = _interopRequireDefault(require("I18n"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var NotificationEmailsActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_NOTIFICATION_EMAILS: null,
  FETCH_NOTIFICATION_EMAILS: null,
  FETCH_NOTIFICATION_EMAIL_DATA: null,
  UPDATE_NOTIFICATION_EMAILS: null
}, 'blog');
exports.NotificationEmailsActionTypes = NotificationEmailsActionTypes;
var FetchNotificationEmailsActionTypes = (0, _actions.createRequestTypes)(NotificationEmailsActionTypes.FETCH_NOTIFICATION_EMAILS);
exports.FetchNotificationEmailsActionTypes = FetchNotificationEmailsActionTypes;
var FetchNotificationEmails = (0, _actions.createRequestActions)(FetchNotificationEmailsActionTypes, {
  keys: ['blogId']
});
exports.FetchNotificationEmails = FetchNotificationEmails;
var FetchNotificationEmailDataActionTypes = (0, _actions.createRequestTypes)(NotificationEmailsActionTypes.FETCH_NOTIFICATION_EMAIL_DATA);
exports.FetchNotificationEmailDataActionTypes = FetchNotificationEmailDataActionTypes;
var FetchNotificationEmailData = (0, _actions.createRequestActions)(FetchNotificationEmailDataActionTypes);
exports.FetchNotificationEmailData = FetchNotificationEmailData;
var loadNotificationEmails = (0, _fluxActions.createAction)(NotificationEmailsActionTypes.LOAD_NOTIFICATION_EMAILS, (0, _actions.mapPayloadTo)('blogId'));
exports.loadNotificationEmails = loadNotificationEmails;
var UpdateNotificationEmailsActionTypes = (0, _actions.createRequestTypes)(NotificationEmailsActionTypes.UPDATE_NOTIFICATION_EMAILS);
exports.UpdateNotificationEmailsActionTypes = UpdateNotificationEmailsActionTypes;
var UpdateNotificationEmails = (0, _actions.createRequestActions)(UpdateNotificationEmailsActionTypes, {
  keys: ['blogId'],
  successMetaCreator: function successMetaCreator(response, props) {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)("" + UpdateNotificationEmailsActionTypes.base + (0, _actions.encodePropKeys)(props, ['blogId']), _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.blog.notifications.notificationEmailsUpdateSuccess')));
  },
  failureMetaCreator: function failureMetaCreator(error, props) {
    var requestStatusMeta = (0, _actions.createRequestStatusMeta)("" + UpdateNotificationEmailsActionTypes.base + (0, _actions.encodePropKeys)(props, ['blogId']), _RequestStatusTypes.default.FAILED);

    if (error && error.responseJSON && error.responseJSON.errorType === 'BLOG_EMAIL_PUBLISH_ERROR') {
      return (0, _extends2.default)({}, requestStatusMeta, (0, _actions.createDangerNotificationMeta)(_I18n.default.text('marketing.blog.notifications.notificationEmailsUpdateFailureCompleteSetup')));
    }

    return (0, _extends2.default)({}, requestStatusMeta, (0, _actions.createDangerNotificationMeta)(_I18n.default.text('marketing.blog.notifications.notificationEmailsUpdateFailureGeneric')));
  }
});
exports.UpdateNotificationEmails = UpdateNotificationEmails;
var updateNotificationEmails = (0, _fluxActions.createAction)(NotificationEmailsActionTypes.UPDATE_NOTIFICATION_EMAILS, (0, _actions.mapPayloadTo)('data'));
exports.updateNotificationEmails = updateNotificationEmails;